import * as React from "react"

import PageContainer from "@podcastsoundboard/ps-lib/components/PageContainer"
import createResetPasswordRequest from "../../api/resetPasswordRequests/create"
import AppBar from "../../components/AppBar"
import Footer from "../../components/Footer"
import FullPageContentContainer from "../../components/FullPageContentContainer"
import { useAppSelector } from "../../redux"
import {
  Alert,
  Avatar,
  Box,
  Button,
  Grid,
  Link,
  Paper,
  Stack,
  TextField,
  Toolbar,
  Typography,
  AlertColor,
} from "@podcastsoundboard/ps-lib/ui"
import LockOutlinedIcon from "@podcastsoundboard/ps-lib/ui/icons/LockOutlined"

export default function ForgotPassword() {
  const darkModeEnabled = useAppSelector((state) => state.darkModeEnabled)

  const [submitDisabled, setSubmitDisabled] = React.useState(true)
  const [submitting, setSubmitting] = React.useState(false)

  const [email, setEmail] = React.useState("")

  const [errorMessage, setErrorMessage] = React.useState("")
  const [messageSeverity, setMessageSeverity] =
    React.useState<AlertColor>("error")

  React.useEffect(() => {
    setSubmitDisabled(!email)
  }, [email])

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault()

    setSubmitting(true)

    createResetPasswordRequest(email)
      .then(() => {
        setSubmitting(false)

        setMessageSeverity("info")
        setErrorMessage("Password reset request sent, please check your email.")

        setEmail("")
      })
      .catch((err) => {
        console.error(err)
        setSubmitting(false)
        setMessageSeverity("error")
        setErrorMessage(
          (err.response?.data as { error?: string } | undefined)?.error ||
            err.message,
        )
      })
  }

  return (
    <>
      <PageContainer darkModeEnabled={darkModeEnabled} className="min-h-screen">
        <AppBar title="Podcast Soundboard" />

        <Toolbar />

        {errorMessage && (
          <Stack className="w-full" spacing={2}>
            <Alert className="rounded-none" severity={messageSeverity}>
              {errorMessage}
            </Alert>
          </Stack>
        )}

        <FullPageContentContainer maxWidth="xs">
          <Paper className="p-8 mt-8 flex flex-col items-center">
            <Avatar className="m-2 bg-primary">
              <LockOutlinedIcon />
            </Avatar>

            <Typography component="h1" variant="h5" color="text.primary">
              Forgot Password
            </Typography>

            <Box
              component="form"
              noValidate
              onSubmit={handleSubmit}
              className="mt-6"
              width="100%"
            >
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    required
                    fullWidth
                    id="email"
                    label="Email Address"
                    name="email"
                    value={email || ""}
                    onChange={(e) => setEmail(e.target.value)}
                    autoComplete="email"
                  />
                </Grid>
              </Grid>

              <Button
                disabled={submitting || submitDisabled}
                type="submit"
                fullWidth
                variant="contained"
                className="mt-6 mb-4"
              >
                {submitting ? "Submitting..." : "Submit"}
              </Button>
              <Grid container justifyContent="center">
                <Grid item style={{ paddingRight: "1rem" }}>
                  <Link href="/app/signin" variant="body2">
                    Sign In
                  </Link>
                </Grid>
                <Grid item>
                  <Link href="/app/signup" variant="body2">
                    Sign Up
                  </Link>
                </Grid>
              </Grid>
            </Box>
          </Paper>
        </FullPageContentContainer>

        <Footer />
      </PageContainer>
    </>
  )
}
